import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import { useParams } from "react-router-dom";
import { X } from "lucide-react";
import useProposalSocialStore from "../../../store/proposal-creators.store";
import { useRemoveProposalSocialAdminHttp } from "../../../hooks/http/admin/proposal-creators/remove-proposal-social.admin.http";
import useProposalSocialSearchStore from "../../../store/proposal-social-search-store";

type AppProps = {
  id: string;
  className?: string;
  searching: boolean;
};

export const RemoveSocialToFilterResult: FunctionComponent<AppProps> = ({
  id,
  className,
  searching,
}) => {
  const { removeById, data: proposalSocials } = useProposalSocialStore();
  const { proposalId } = useParams();
  const { setData: setSearchData, data: searchData } =
    useProposalSocialSearchStore();

  const {
    execute: removeProposalSocialHttp,
    fetching: fetchingRemoveProposalSocial,
  } = useRemoveProposalSocialAdminHttp();

  const { toast } = useToast();

  const handleRemoveSocialToFilterResult = async () => {
    if (!proposalId) {
      return;
    }
    if (!proposalSocials) {
      return;
    }
    const response = await removeProposalSocialHttp({
      body: null,
      pathParams: {
        proposalId,
        socialId: id,
      },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    console.log(searching);
    if (searching) {
      // update search results with new data replacing the old data at that index
      // set proposalSocial to null
      setSearchData(
        searchData.map((item) =>
          item.proposalSocial?.id === id
            ? { ...item, proposalSocial: null }
            : item
        )
      );
      return;
    }
    removeById(id);
  };

  return (
    <Button
      disabled={fetchingRemoveProposalSocial}
      onClick={handleRemoveSocialToFilterResult}
      className={`border-rejectbuttonborder backdrop-blur-sm w-16 h-10 bg-rejectbuttonbg border font-semibold text-rejectbuttontext tracking-wider ${className}`}
    >
      {fetchingRemoveProposalSocial ? <Spinner width={15} /> : <X />}
    </Button>
  );
};
